import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchSkiSchools, setSelectedSkiSchool } from "../../Reducers/Login/Actions";
import SkiSchoolSelector from "../../Components/SkiSchoolSelector/SkiSchoolSelector";
import { DefaultRootState } from "../../Types/Types";

const SkiSchoolSelectorContainer = (props) => {
  const dispatch = useDispatch();
    const { isValidLogin, selectedSkiSchool, skiSchools } = useSelector((state : DefaultRootState) => state.login);
    return (<SkiSchoolSelector
        {...props}
        isValidLogin={isValidLogin}
        selectedSkiSchool={selectedSkiSchool}
        skiSchools={skiSchools}
        fetchSkiSchools={() => dispatch(fetchSkiSchools())}
        selectSkiSchool={(skischool) => dispatch(setSelectedSkiSchool(skischool))}

    />)
    }

export default SkiSchoolSelectorContainer